import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const verticalSlideModalBase = css`
  box-shadow: ${theme.shadows.heavy};
  border: none;
  overflow: auto;
  background: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  height: calc(100% - 24px - var(--vsm-height-offset, 0px));
  width: 100%;
  bottom: 0;
  z-index: ${theme.zIndex.modals};

  :focus {
    outline: none;
  }
`;

export const verticalSlideModalDirectionUp = css`
  border-radius: ${theme.borderRadius.medium} ${theme.borderRadius.medium} 0 0;
  bottom: 0;
`;

export const verticalSlideModalDirectionDown = css`
  border-radius: 0 0 ${theme.borderRadius.medium} ${theme.borderRadius.medium};
  top: 0;
`;

export const verticalSlideModalFixed = css`
  position: fixed;
`;

/**
 * Mirrors `styles.getAdjustedHeight` for the full-height variant. Only applied when the runtime
 * `heightOffset` is non-zero; the offset is provided via the `--vsm-height-offset` CSS variable.
 */
export const verticalSlideModalFullHeightAdjusted = css`
  height: calc(100% - var(--vsm-height-offset, 0px)) !important;
  bottom: 0 !important;
  top: auto !important;
`;

/**
 * Backdrop overlay. `z-index` and `top` are runtime values (stack index + shell height offset) provided
 * via the `--vsm-backdrop-z-index` and `--vsm-backdrop-top` CSS variables. The background colour is driven
 * by the motion animation variants.
 */
export const verticalSlideModalBackdrop = css`
  z-index: var(--vsm-backdrop-z-index, ${theme.zIndex.modals});
  top: var(--vsm-backdrop-top, 0px) !important;
`;

export const verticalSlideModalContent = css`
  flex: 1;
  overflow-y: auto;
  position: relative;

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.small};
  }
`;

export const verticalSlideModalHeader = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing(2)};
`;
